import React, { useState } from "react";
import { MdArchive } from "react-icons/md";
import { TbActivityHeartbeat } from "react-icons/tb";
import { LineWave } from "react-loader-spinner";
import { useQuery } from "react-query";
import { useStudent } from "src/contexts/student";
import { Activity } from "src/modules/fithub-shared/notifications/index.types";
import api from "src/rest/api";
import ActivityItem from "../ActivityItem";

// import { Container } from './styles';

const Activities: React.FC = () => {
  const { student } = useStudent();

  const [activities, setActivities] = useState<Activity[]>();

  const query = useQuery(["activities", student?.id], () =>
    api
      .post<Activity[]>("/activities/list", { ref: student?.id })
      .then((res) => {
        setActivities(res.data);
      }),
  );

  const [remove, setRemove] = useState<string[]>([]);

  function RemoveSelected() {
    api
      .post("/notification/dismiss", {
        ids: `(${remove.map((id) => `'${id}'`).join(",")})`,
      })
      .then(() => {
        setRemove([]);
        setActivities(undefined);
        query.refetch();
      });
  }

  function toggle(id: string) {
    if (remove.includes(id)) {
      // Remove o item sem modificar o array original
      setRemove(remove.filter((item) => item !== id));
    } else {
      // Adiciona o item ao array
      setRemove([...remove, id]);
    }
  }

  return (
    <div className="max-h-[50vh] overflow-auto">
      <ul className="relative flex flex-1 flex-col">
        {remove.length ? (
          <button
            className="mb-3 mr-2 flex flex-row items-center gap-2 rounded-full bg-zinc-500 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-zinc-600 active:opacity-70 dark:bg-zinc-700 dark:hover:bg-zinc-600"
            style={{
              width: "fit-content",
              margin: "12px auto",
              fontSize: 14,
              padding: "6px 16px",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
            onClick={RemoveSelected}
          >
            <MdArchive size={18} className="mr-1" />
            <span className="font-bold text-white">Arquivar Selecionados</span>
          </button>
        ) : null}

        {activities && activities.length > 0 ? (
          <>
            {activities.map((e, i) => (
              <ActivityItem
                key={`${i}_Act`}
                activity={e}
                selected={remove.includes(e.id)}
                select={toggle}
              />
            ))}
          </>
        ) : (
          <div className="flex flex-1 flex-col items-center justify-center py-8 text-zinc-500 dark:text-zinc-400">
            {query.isLoading ? (
              <LineWave color="#dd1a30" />
            ) : (
              <div className="flex flex-col items-center">
                <TbActivityHeartbeat size={32} />
                <p>Não há atividades notificadas!</p>
              </div>
            )}
          </div>
        )}
      </ul>
    </div>
  );
};

export default Activities;
